import dynamic from 'next/dynamic'

export const DynamicServiceSkeleton = dynamic(() =>
	import('./ServiceSkeleton').then(({ ServiceSkeleton }) => ServiceSkeleton)
)
